import React from "react";
import PropTypes from "prop-types";
import "./SpinnerForContainer.less";

class SpinnerForContainer extends React.Component {
  render() {
    return (
      <div className={`spinner-container ${this.props.className || ""}`}>
        <div className={this.props.size === "sm" ? "loaderForContainer-sm" : "loaderForContainer-lg"}></div>
        {this.props.loadingText && (
          <div className={this.props.size === "sm" ? "loading-text-sm" : "loading-text-lg"}>{this.props.loadingText}</div>
        )}
      </div>
    );
  }
}

SpinnerForContainer.propTypes = {
  className: PropTypes.string,  // Optional custom class name for extra customization
  loadingText: PropTypes.string,  // The text to display below the spinner
};

export default SpinnerForContainer;
